import React from 'react';
import PremiumLogo from '../../images/premium.png';
import SpadesIcon from '../../icons/spades.svg';
import ClubsIcon from '../../icons/clubs.svg';
import HeartsIcon from '../../icons/hearts.svg';
import { getMediaUrl } from '../../../../utils/utils';
import './PremiumBanner.scss';
import BrowserLink from '../../../../components/BrowserLink';

export function PremiumBanner({ ...props }) {
  return (
    <div className="PremiumBanner" {...props}>
      <div className="PremiumBanner__content">
        <div className="PremiumBanner__content-main">
          <img src={getMediaUrl(PremiumLogo)} alt="POKER COACHING PREMIUM" className="PremiumBanner__logo" />
          <p className="PremiumBanner__description">Get this Course, plus unlimited access to 175+ courses, 950 quizzes, 50 challenge webinars, and much more</p>
          <BrowserLink href="https://pokercoaching.com/store/" className="PremiumBanner__get-btn">Get premium</BrowserLink>
        </div>

        <div className="PremiumBanner__content-second">
          <dl className="PremiumBanner__advantages">
            <dt>
              <div className="PremiumBanner__advantages-icon">
                <img src={getMediaUrl(SpadesIcon)} alt="" />
              </div>
              Make progress
            </dt>
            <dd>Explore any interest to trending topic, take prerequisites, and advanced your skills</dd>

            <dt>
              <div className="PremiumBanner__advantages-icon">
                <img src={getMediaUrl(ClubsIcon)} alt="" />
              </div>
              Save money
            </dt>
            <dd>Spend less money on your learning if you plan to take multiple courses this year</dd>

            <dt>
              <div className="PremiumBanner__advantages-icon">
                <img src={getMediaUrl(HeartsIcon)} alt="" />
              </div>
              Choose your path
            </dt>
            <dd>Learn at your own pace, move petween multiple courses, or switch to a different course</dd>
          </dl>
        </div>
      </div>
    </div>
  );
}
